export enum RecurrenceType {
  Daily = "Daily",
  Weekly = "Weekly",
}
